import BaseUtil from "../../util/BaseUtil";

const type = `@@ActionType/UPDATE@${__filename}`;

const dueDateTypeMap = {
    before: "未到预产期",
    after: "已过预产期",
}

const initState = {
    selectedDueDateType: "before", // 选中的tab
    selectedUnitIds: null,
    unitsMap: null,

    keyword: "", // 搜索keyword
    sortInfo: null, // 搜索排序
    tableLoading: false,
    users: null, // 查找到的数据

    editModalVisible: false, // 新增编辑modal
    editUser: null, // 编辑user
    editLoading: false,

    pageable: {
        current: 1,
        limit: 30,
    }
};

const [viewModel, update, reset] = BaseUtil.getViewModel(initState, type);

export {
    update,
    reset,
    dueDateTypeMap,
};
export default viewModel;
